


























import { Component, Vue } from 'vue-property-decorator';

import { CompanyStore } from '@/store/company';

import LocationSelect from './StandardLayoutLocationSelect.vue';


@Component({
  components: {
    LocationSelect,
  },
})
export default class StandardLayoutTitle extends Vue {
  @CompanyStore.Bind.State companyName!: CompanyStore.State<'companyName'>;
}
